function InvalidPropertyError(message) {
  this.name = 'InvalidPropertyError';
  this.message = message;
  this.stack = (new Error()).stack;
}

InvalidPropertyError.prototype = Object.create(Error.prototype);
InvalidPropertyError.prototype.constructor = InvalidPropertyError;

module.exports = InvalidPropertyError;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/optimizer/level-2/invalid-property-error.js
// module id = 1044
// module chunks = 0